import { Reducer } from 'interfaces'
import { CryptoRewardsReducer } from 'components/features/rewards/rewardsPane/types/store'
import { UserRewardsStateReducerChangeStateAction } from 'components/features/rewards/rewardsPane/store/actions/userRewardsState'
import { concatCollections, createEmptyCollection, normalize } from 'helpers/normalizeHelpers'
import { WsMessageAction } from 'actions/webSocketActions'
import { normalizeWalletItem } from 'components/features/rewards/rewardsPane/store/helpers/wallet'
import { SellCryptoAction } from 'components/features/rewards/rewardsPane/store/actions/paneState'
import { GET_REWARDS_SUMMARY } from 'actions/bountyActions'

const INITIAL_STATE: CryptoRewardsReducer = {
  cryptoWallet: createEmptyCollection(),
}

export const cryptoRewardsReducer: Reducer<CryptoRewardsReducer> = (prevState = INITIAL_STATE, action) => {
  switch (action.type) {
    case UserRewardsStateReducerChangeStateAction.type:
      return {
        ...prevState,
        ...action.payload,
      }

    case WsMessageAction.type: {
      if (action.payload.event !== 'reward_balances_changed' || !action.payload.data.reward_account.crypto_balances || action.payload.data.reward_account.crypto_balances.length === 0) {
        return prevState
      }

      const newWallet = normalize(action.payload.data.reward_account.crypto_balances.map(normalizeWalletItem), 'id')
      return {
        ...prevState,
        cryptoWallet: concatCollections(prevState.cryptoWallet, newWallet),
      }
    }

    case SellCryptoAction.type: {
      if (action.meta !== 'success' || !action.payload.response?.reward_account?.crypto_balances) {
        return prevState
      }


      const newWallet = normalize(action.payload.response.reward_account.crypto_balances.map(normalizeWalletItem), 'id')
      return {
        ...prevState,
        cryptoWallet: concatCollections(prevState.cryptoWallet, newWallet),
      }
    }

    case GET_REWARDS_SUMMARY: {
      if (action.meta !== 'success') {
        return prevState
      }

      const { crypto_balances } = action.payload.response

      const withCryptoWallet = (() => {
        if (!crypto_balances) {
          return {}
        }

        const nextResponse = crypto_balances.map(normalizeWalletItem)
        return {
          cryptoWallet: normalize(nextResponse, 'id'),
        }

      })()

      return {
        ...prevState,
        ...withCryptoWallet,
      }
    }

    default:
      return prevState
  }
}
